import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmActionModalComponent } from 'shared/common/confirm-action.service';
import { MaterialModule } from 'shared/modules/material/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { ControlsModule } from 'shared/modules/controls/controls.module';

@NgModule({
  declarations: [
    ConfirmActionModalComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    ControlsModule
  ],
  exports: [
    ConfirmActionModalComponent
  ],
})
export class ConfirmActionModule {
}
